export const GET_STATIC_PAGES = 'staticPages/GET_STATIC_PAGES';



// WEBPACK FOOTER //
// ./src/constants/staticPages.js